import {
    ExpandIcon,
    MoreVertIcon,
} from 'common/components/icons';

import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import CudaPaper from 'common/components/CudaPaper';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import React from 'react';
import SearchBar from 'common/components/SearchBar';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import classnames from 'classnames';
import ContainerAccordion, { AccordionDetails, AccordionSummary } from './ContainerAccordion';
import Rlc from './Rlc';
import ContainerInfo from './ContainerInfo';
import { withStyles } from '@material-ui/core/styles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

const styles = {
    container: {
        padding: '10px 1px',
        alignSelf: 'flex-start'
    },
    emptyTableCell: {
        textAlign: 'center',
        fontSize: '16px',
        color: '#777777',
        fontWeight: '300',
        height: '200px',
    },
    actionHeadCell: {
        textAlign: 'center'
    },
    actionCell: {
        display: 'flex',
        justifyContent: 'center'
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: 'transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    td: {
        border: '1px solid rgba(224, 224, 224, 1)',
    },
    menulink: {
        textDecoration: 'none',
        color: '#000',
    },
    result_limited: {
        color: 'rgba(0, 0, 0, 0.87)',
        fontSize: '0.8125rem',
        fontWeight: '400',
        textAlign: 'center',
        display: 'block',
        padding: '10px',
    },
    domainCell: {
        animation: 'grow .5s',
        display: 'block',
        padding: '13px',
    },
    servicesLocations: {
        width: '100%',
        animation: 'grow .5s',
        backgroundColor: '#ffffce',
        padding: '13px',
        '& div': {
            textDecoration: 'underline',
            marginBottom: '5px',
            display: 'block',
        },
        '& ul': {
            listStyleType: 'none',
            padding: 0,
            margin: 0,
        }
    },
    '@keyframes grow': {
        '0%': {
            opacity: 0
        },
        '100%': {
            opacity: 1
        }
    },
    service: {
        display: 'block',
        textAlign: 'center'
    },
    accountColumn: {
        extend: 'td',
        backgroundColor: 'rgba(224, 224, 224, 1)',
    },
    applicationColumn: {
        extend: 'td',
    },
    endpointColumn: {
        extend: 'td',
        textAlign: 'left',
        padding: '5px',
    },
    typeColumn: {
        extend: 'td',
        textAlign: 'center'
    },
    regionColumn: {
        extend: 'td',
    },
    serviceIdColumn: {
        extend: 'td',
    },
    usersColumn: {
        extend: 'td',
    },
    smallText: {
        fontSize: '13px',
        marginLeft: '10px',
    },
    myChip: {
        userSelect: 'all'
    },
    serverColumn: {
        extend: 'td',
        textAlign: 'left',
        padding: "5px",
    },
    serviceLocationsAccordion: {
        width: '400px',
    },
}

class SearchServicesTable extends React.Component {
    state = {
        expanded: true,
        anchorEl: null,
        endpointMenu: null,
        application_id: null,
        servicesLocationsMenu: null,
        service_id: null,
        serverMenu: null,
        server_id: null,
        appMenu: null,
    };
    handleExpandClick = () => {
        this.setState(state => ({ expanded: !state.expanded }));
    };

    endpointMenuClick = (event, application_id, service_id) => {
        this.setState({ endpointMenu: event.currentTarget, application_id, service_id });
    };

    endpointMenuClose = () => {
        this.setState({ endpointMenu: null, application_id: null });
    };

    servicesLocationsMenuClose = () => {
        this.setState({ servicesLocationsMenu: null, application_id: null });
    };

    serversMenuClick = (event, server_id) => {
        this.setState({ serverMenu: event.currentTarget, server_id});
    };

    serversMenuClose = () => {
        this.setState({ serverMenu: null, server_id: null});
    };

    appsMenuClick = (event, application_id) => {
        this.setState({ appMenu: event.currentTarget, application_id});
        
    };

    appsMenuClose = () => {
        this.setState({ appMenu: null, application_id: null});
    };

    render() {

        const { endpointMenu, serverMenu, appMenu } = this.state;
        const {
            classes,
            isLoading,
            fetcher,
            items,
            count,
            onSearch,
            toggleOptionsDialog,
            toggleEndpointDialog,
            toggleSecondaryAppDialog,
            toggleServiceLocations,
            toggleServerHealthDialog,
            servicesLocations,
            domains,
            fetchRlc,
            fetchContainerInfo,
        } = this.props;

        return (
            <Grid className={classes.container}>
                <CudaPaper loading={fetcher.loading || isLoading}>
                    <CardActions className={classes.actions} disableactionspacing="true">
                        Services Status <span className={classes.smallText}>(Min 3 chars. Search by domain, endpoint IP, application name/id, account name/id, user email or license serial number)</span>
                        <IconButton
                            className={classnames(classes.expand, {
                                [classes.expandOpen]: this.state.expanded,
                            })}
                            onClick={this.handleExpandClick}
                            aria-expanded={this.state.expanded}
                            aria-label="Show more"
                        >
                            <ExpandIcon />
                        </IconButton>
                    </CardActions>
                    <Collapse in={this.state.expanded} timeout="auto" unmountOnExit>
                        <SearchBar onChange={onSearch} placeholder='Search for IP, Account id, Account email' autoFocus={false} />
                        <Menu
                            id="endpointMenu"
                            anchorEl={endpointMenu}
                            open={Boolean(endpointMenu)}
                            onClose={this.endpointMenuClose}
                        >
                            <MenuItem
                                onClick={() => { this.endpointMenuClose(); toggleEndpointDialog(this.state.service_id) }}>
                                Advanced options
                            </MenuItem>
                            <MenuItem
                                onClick={() => { this.endpointMenuClose(); toggleServiceLocations(this.state.service_id) }}>
                                Service locations
                            </MenuItem>
                        </Menu>
                        <Menu
                            id="serverMenu"
                            anchorEl={serverMenu}
                            open={Boolean(serverMenu)}
                            onClose={this.serversMenuClose}
                        >
                            <MenuItem
                                onClick={() => { this.serversMenuClose(); toggleServerHealthDialog(this.state.server_id) }}>
                                Detailed Health Report (Containers Only)
                            </MenuItem>
                        </Menu>
                        <Menu
                            id="appMenu"
                            anchorEl={appMenu}
                            open={Boolean(appMenu)}
                            onClose={this.appsMenuClose}
                        >
                            <MenuItem
                                onClick={() => { this.appsMenuClose(); toggleSecondaryAppDialog(this.state.application_id) }}>
                                Convert App to Secondary
                            </MenuItem>
                        </Menu>
                        {items.length < count &&
                            <span className={classes.result_limited}>(showing {items.length} items out of {count})</span>
                        }
                        <Grid item xs={12} className={classes.tableContainer}>
                            <Table>
                                <TableBody>
                                    {items.length > 0 ?
                                        items.map((account, i) => {
                                            const accountRowSpan = account.apps.reduce((total, application) => {
                                                return total + application.services.length;
                                            }, 0)

                                            let appropriateColor = (val) => val === 'Up' ? 'secondary' : val === 'Down' ? 'error' : 'textPrimary'

                                            return <React.Fragment key={account.id}>
                                                <TableRow>
                                                    <TableCell colSpan={5} className={classes.accountColumn}>
                                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                            <div>
                                                                <IconButton
                                                                    aria-label="More"
                                                                    aria-haspopup="true"
                                                                    onClick={() => { toggleOptionsDialog(account.id) }}
                                                                >
                                                                    <MoreVertIcon />
                                                                </IconButton>
                                                            </div>
                                                            <div style={{ flexShrink: 1, width: '70%', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                                                                {account.name}
                                                            </div>
                                                            <div style={{ flexShrink: 0, marginLeft: '10px' }}>
                                                                <Typography variant="caption" color="primary">{account.id}</Typography>
                                                            </div>
                                                        </div>
                                                    </TableCell>
                                                </TableRow>
                                                {(accountRowSpan === 0) ? 
                                                    <TableRow>
                                                        <TableCell colSpan={5} style={{ textAlign: 'center' }} align='center'>
                                                            No Applications
                                                        </TableCell>
                                                    </TableRow>
                                                    :
                                                    <TableRow variant="head">
                                                        <TableCell style={{ textAlign: 'center' }} align='center' className={classes.td}>Application</TableCell>
                                                        <TableCell style={{ textAlign: 'center' }} align='center' className={classes.td}>Regions</TableCell>
                                                        <TableCell style={{ textAlign: 'center' }} align='center' className={classes.td}>Servers</TableCell>
                                                        <TableCell style={{ textAlign: 'center' }} align='center' className={classes.td}>Endpoint IP:Port</TableCell>
                                                        <TableCell style={{ textAlign: 'center' }} align='center' className={classes.td}>Domains</TableCell>
                                                    </TableRow>
                                                }
                                                {account.apps.map((application, ia) => {
                                                    const applicationRowSpan = application.services.length
                                                    return application.services.map((service, is) => {
                                                        return (<TableRow key={`${application.id}_${is}`}>
                                                            {is === 0 &&
                                                                <TableCell
                                                                    rowSpan={applicationRowSpan}
                                                                    className={classes.applicationColumn}
                                                                >
                                                                    {application.name} ({application.id})
                                                                    <Grid container>
                                                                        <Grid item xs={8} container alignItems="center">
                                                                            <Typography color="textSecondary">{application.cname}</Typography>
                                                                        </Grid>
                                                                        <Grid item container xs={3} alignItems="center" justifyContent='flex-end'>
                                                                            <Typography variant="caption" color="textSecondary">(CNAME)</Typography>
                                                                        </Grid>
                                                                        <Grid item xs={1}>
                                                                            <IconButton
                                                                                aria-label="More"
                                                                                aria-haspopup="true"
                                                                                onClick={e => { this.appsMenuClick(e, application.id) }}
                                                                                style={{padding: "1px"}}
                                                                            >
                                                                                <MoreVertIcon />
                                                                            </IconButton>
                                                                        </Grid>
                                                                    </Grid>
                                                                </TableCell>
                                                            }
                                                            {is === 0 &&
                                                                <TableCell rowSpan={applicationRowSpan} className={classes.regionColumn}>
                                                                    <Grid container>
                                                                        {application.regions.map((r, rIndex) =>
                                                                            <Grid item container xs={12} key={'rgc' + rIndex}>
                                                                                <Grid item xs={5}>
                                                                                    {r.display_name}
                                                                                </Grid>
                                                                                <Grid item container xs={7} justifyContent="flex-end">
                                                                                    <Typography style={{ display: 'inline-block' }} color="textSecondary" variant='caption'>{r.ip_range}(priority {r.priority})</Typography>
                                                                                </Grid>
                                                                            </Grid>)
                                                                        }
                                                                    </Grid>
                                                                </TableCell>
                                                            }
                                                            {is === 0 &&
                                                                <TableCell rowSpan={applicationRowSpan} className={classes.serverColumn}>
                                                                    <Grid container direction="column" spacing={1}>
                                                                        {application.servers.map((s, sIndex) =>
                                                                            <Grid item container key={sIndex} alignItems="center" spacing={1}>
                                                                                <Grid item xs={1}>
                                                                                    <IconButton
                                                                                        aria-label="More"
                                                                                        aria-haspopup="true"
                                                                                        onClick={e => { this.serversMenuClick(e, s.id) }}
                                                                                        style={{padding: "1px"}}
                                                                                    >
                                                                                        <MoreVertIcon />
                                                                                    </IconButton>
                                                                                </Grid>
                                                                                <Grid item xs={3}>
                                                                                    {s.name}
                                                                                </Grid>
                                                                                <Grid item xs={2}>
                                                                                    <Typography variant="subtitle2" color={appropriateColor(s.health)}>{s.health}</Typography>
                                                                                </Grid>
                                                                                <Grid item>
                                                                                    {s.host}:{s.port}
                                                                                </Grid>
                                                                            </Grid>)
                                                                        }
                                                                    </Grid>
                                                                </TableCell>
                                                            }
                                                            <TableCell className={classes.endpointColumn}>
                                                                <Grid container alignItems='center'>
                                                                    <Grid item xs={2}>
                                                                        <IconButton
                                                                            aria-label="More"
                                                                            aria-owns={endpointMenu ? "services_locations" : undefined}
                                                                            aria-haspopup="true"
                                                                            onClick={e => { this.endpointMenuClick(e, application.id, service.id) }}
                                                                            style={{padding: "1px"}}
                                                                        >
                                                                            <MoreVertIcon />
                                                                        </IconButton>
                                                                    </Grid>
                                                                    <Grid container item xs={10} justifyContent='center' >
                                                                        <Grid item xs={12} container justifyContent="flex-end">
                                                                            <span>{service.ip}:{service.port} @ vs_{service.id} </span>
                                                                        </Grid>
                                                                        <Grid item xs={12} >
                                                                            <Typography color='textSecondary' variant='caption'>({service.type})</Typography>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>
                                                            </TableCell>
                                                            {service.domains &&
                                                                <TableCell style={{ padding: 0 }}>
                                                                    <div className={classes.domainCell}>
                                                                        <span>
                                                                            {service.domains.slice(0, 5).join(", ")}
                                                                        </span>
                                                                        {service.domains.length > 5 &&
                                                                            <span> ({service.domains.length - 5} more)</span>
                                                                        }
                                                                    </div>
                                                                    {servicesLocations[service.id] &&
                                                                    <div className={classes.servicesLocations}>
                                                                        <div>Service Locations</div>
                                                                        <ul>
                                                                            {
                                                                                servicesLocations[service.id].map((item, index) =>
                                                                                    <li key={index}>
                                                                                        <span>{item.cwaf__hostname}</span>:
                                                                                        <span>{item.port}</span>
                                                                                        <span>({item.cwaf__serial})</span>
                                                                                    </li>
                                                                                )
                                                                            }
                                                                        </ul>
                                                                    </div>}
                                                                    {domains[service.id] &&
                                                                        <React.Fragment>
                                                                            {/* WaaS Containers */}
                                                                            <ContainerAccordion className={classes.serviceLocationsAccordion}>
                                                                                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                                                                    WaaS Containers
                                                                                </AccordionSummary>
                                                                                <AccordionDetails>
                                                                                    <Grid container>
                                                                                        {Object.keys(domains[service.id]['waas_containers']).map(rlcId =>
                                                                                            <Grid item container xs={12} key={rlcId}>
                                                                                                <Rlc
                                                                                                    vsId={service.id}
                                                                                                    rlcId={rlcId}
                                                                                                    name={domains[service.id]['waas_containers'][rlcId]['display_name']}
                                                                                                    data={domains[service.id]['waas_containers'][rlcId]}
                                                                                                    fetchRlc={fetchRlc}
                                                                                                />
                                                                                            </Grid>
                                                                                        )}
                                                                                    </Grid>
                                                                                </AccordionDetails>
                                                                            </ContainerAccordion>
                                                                            {/* Customer Containers */}
                                                                            <ContainerAccordion className={classes.serviceLocationsAccordion}>
                                                                                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                                                                    Customer Containers
                                                                                </AccordionSummary>
                                                                                <AccordionDetails>
                                                                                    <Grid container>
                                                                                        {Object.keys(domains[service.id]['customer_containers']).map(index =>
                                                                                            <Grid item container xs={12} key={domains[service.id]['customer_containers'][index]['cc_id']}>
                                                                                                <ContainerInfo
                                                                                                    key={domains[service.id]['customer_containers'][index]['cc_id']}
                                                                                                    vsId={service.id}
                                                                                                    container_index={index}
                                                                                                    name={domains[service.id]['customer_containers'][index]['name']}
                                                                                                    data={domains[service.id]['customer_containers'][index]}
                                                                                                    fetchContainerInfo={fetchContainerInfo}
                                                                                                />
                                                                                            </Grid>
                                                                                        )}
                                                                                    </Grid>
                                                                                </AccordionDetails>
                                                                            </ContainerAccordion>
                                                                        </React.Fragment>
                                                                    }
                                                                </TableCell>
                                                            }
                                                        </TableRow>)                                            
                                                    })
                                                })}
                                            </React.Fragment>
                                        })
                                        :
                                        <TableRow >
                                            <TableCell colSpan="6" className={classes.emptyTableCell}>
                                                No results
                                            </TableCell>
                                        </TableRow>
                                    }
                                </TableBody>
                            </Table>
                        </Grid>
                    </Collapse>
                </CudaPaper>
            </Grid>
        )
    };
};

export default withStyles(styles)(SearchServicesTable);